import { IDealRoom } from '@app/interfaces/deal-room';
import React from 'react';
import { capitalize } from 'utils/utils';
import * as S from './DealRoomInfo.styles';

interface DealRoomInfoProps {
  dealRoom: IDealRoom | null;
}

export const DealRoomInfo: React.FC<DealRoomInfoProps> = ({ dealRoom }) => {
  return (
    <S.Wrapper>
      {dealRoom && (
        <S.Content>
          <S.Title>{`${capitalize(dealRoom?.title)}`}</S.Title>
        </S.Content>
      )}
    </S.Wrapper>
  );
};
